export const pt = {
    subject: `Confirme sua conta`,
    title: `Confirme sua conta`,
    message: `Por favor clique no botão abaixo para confirmar sua conta.`,
    button: `Confirmar Conta`,
    link: `Se o botão acima não funcionar, copie e cole este link no seu navegador:`,
    thanks: `Obrigado!`,
    text: `Por favor clique no seguinte link para confirmar sua conta:\n\n{{confirmUrl}}\n\nObrigado!`,
    success: `Conta confirmada com sucesso! Agora você pode entrar.`,
};
//# sourceMappingURL=pt.js.map